import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
Vue.config.productionTip = false
import hevueImgPreview from 'hevue-img-preview'
import router from './router'
import axios from 'axios'
import './plugins/element.js'
Vue.prototype.$http=axios
Vue.use(hevueImgPreview)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
